export default __webpack_public_path__ + "static/media/hummer.cb772ebd.jpg";